import React, { useState, useEffect } from 'react';
import Toast from './Toast';
import toastManager from '../utils/toastManager';

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const unsubscribe = toastManager.addListener((toast) => {
      setToasts(prevToasts => {
        const existingIndex = prevToasts.findIndex(t => t.id === toast.id);
        
        if (existingIndex >= 0) {
          // 更新现有toast
          const newToasts = [...prevToasts];
          newToasts[existingIndex] = toast;
          return newToasts;
        } else {
          // 添加新toast
          return [...prevToasts, toast];
        }
      });
    });

    return unsubscribe;
  }, []);

  const handleClose = (id) => {
    toastManager.hide(id);
  };

  // 检测是否为微信环境
  const isWechat = /MicroMessenger/i.test(navigator.userAgent);
  const isMobile = window.innerWidth <= 480;

  return (
    <div className="toast-container-wrapper">
      {toasts.map((toast, index) => (
        <div
          key={toast.id}
          className={`toast-item toast-item-${toast.type}`}
          style={{
            zIndex: 99999 + index,
          }}
        >
          <Toast
            message={toast.message}
            type={toast.type}
            visible={toast.visible}
            onClose={() => handleClose(toast.id)}
            duration={toast.duration}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;